import styled from "styled-components";

export const LmsDashboardWrapper = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  background: #f6f8f4;
  color: #20332e;

  .lms-sidebar {
    position: sticky;
    top: 0;
    height: 100vh;
    background: #ffffff;
    border-right: 1px solid #dce5df;
    padding: 1.25rem;
  }

  .lms-sidebar-logo {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 2rem;
  }

  .lms-sidebar-logo-text {
    color: #17342f;
    font-weight: 800;
    letter-spacing: 0;
  }

  .lms-sidebar nav {
    display: grid;
    gap: 0.4rem;
  }

  .lms-sidebar a {
    min-height: 46px;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    border-radius: 8px;
    color: #526762;
    font-weight: 800;
    letter-spacing: 0;
    padding: 0 0.85rem;
  }

  .lms-sidebar a.active,
  .lms-sidebar a:hover {
    background: #e8f3ef;
    color: #1d6257;
  }

  .lms-dashboard-shell {
    min-width: 0;
  }

  .lms-topbar {
    position: sticky;
    top: 0;
    z-index: 3;
    min-height: 72px;
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: space-between;
    background: rgba(246, 248, 244, 0.92);
    border-bottom: 1px solid rgba(32, 51, 46, 0.08);
    backdrop-filter: blur(12px);
    padding: 0 2rem;
  }

  .lms-topbar span {
    display: block;
    color: #68817a;
    font-size: 0.82rem;
    font-weight: 800;
    text-transform: uppercase;
  }

  .lms-topbar strong {
    color: #1e3833;
  }

  .lms-icon-button {
    display: none;
    width: 42px;
    height: 42px;
    border: 1px solid #d6e0dc;
    border-radius: 8px;
    background: #ffffff;
    color: #1d6257;
    cursor: pointer;
  }

  .lms-logout {
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    border: 1px solid #d6e0dc;
    border-radius: 8px;
    background: #ffffff;
    color: #2c443f;
    cursor: pointer;
    font-weight: 800;
    padding: 0 0.85rem;
  }

  .lms-dashboard-content {
    width: min(1180px, calc(100% - 2rem));
    margin: 0 auto;
    padding: 2rem 0 3rem;
  }

  .eyebrow {
    margin: 0;
    color: #2e7d6f;
    font-size: 0.78rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .lms-hero {
    border-radius: 8px;
    background:
      linear-gradient(135deg, rgba(36, 107, 96, 0.94), rgba(44, 93, 128, 0.92)),
      #246b60;
    color: #ffffff;
    padding: clamp(1.5rem, 4vw, 3rem);
  }

  .lms-hero h1,
  .lms-journey h2,
  .lms-placeholder-page h1,
  .lms-empty-state h2 {
    text-transform: none;
    letter-spacing: 0;
  }

  .lms-hero h1 {
    max-width: 13ch;
    margin: 0.55rem 0;
    font-size: clamp(2.25rem, 5vw, 4.2rem);
    line-height: 1;
  }

  .lms-hero p {
    max-width: 56rem;
    margin-bottom: 0;
    color: rgba(255, 255, 255, 0.86);
  }

  .lms-card-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
    margin-top: 1rem;
  }

  .lms-progress-card,
  .lms-journey,
  .lms-empty-state,
  .lms-placeholder-page {
    background: #ffffff;
    border: 1px solid #dce5df;
    border-radius: 8px;
    box-shadow: 0 18px 42px rgba(32, 51, 46, 0.06);
  }

  .lms-progress-card {
    padding: 1.25rem;
  }

  .lms-progress-card span {
    color: #60716d;
    font-weight: 800;
  }

  .lms-progress-card strong {
    display: block;
    margin: 0.3rem 0;
    color: #17342f;
    font-size: 2rem;
    line-height: 1;
  }

  .lms-progress-card p,
  .lms-placeholder-page p,
  .lms-empty-state p {
    margin: 0;
    color: #60716d;
  }

  .lms-journey {
    margin-top: 1rem;
    padding: 1.25rem;
  }

  .lms-journey h2 {
    margin-bottom: 1rem;
    color: #17342f;
    font-size: 1.45rem;
  }

  .lms-journey-track {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .lms-journey-track article {
    min-height: 112px;
    display: grid;
    align-content: start;
    gap: 0.7rem;
    border-radius: 8px;
    background: #f3f7f4;
    padding: 1rem;
  }

  .lms-journey-track span {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #246b60;
    color: #ffffff;
    font-weight: 900;
  }

  .lms-journey-track p {
    margin: 0;
    color: #2c443f;
    font-weight: 800;
    line-height: 1.35;
  }

  .lms-empty-state,
  .lms-placeholder-page {
    margin-top: 1rem;
    padding: 1.5rem;
  }

  .lms-empty-state {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: center;
    gap: 1rem;
  }

  .lms-empty-icon {
    width: 54px;
    height: 54px;
    display: grid;
    place-items: center;
    border-radius: 8px;
    background: #e8f3ef;
    color: #1d6257;
    font-size: 1.45rem;
  }

  .lms-empty-state h2,
  .lms-placeholder-page h1 {
    margin: 0 0 0.35rem;
    color: #17342f;
  }

  .lms-primary-action {
    min-height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    background: #246b60;
    color: #ffffff;
    cursor: pointer;
    font-weight: 900;
    line-height: 1;
    padding: 0 1rem;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
  }

  .lms-placeholder-page {
    max-width: 760px;
  }

  .lms-placeholder-page .lms-primary-action {
    margin-top: 1rem;
  }

  @media (max-width: 980px) {
    grid-template-columns: 1fr;

    .lms-icon-button {
      display: grid;
      place-items: center;
    }

    .lms-sidebar {
      position: fixed;
      z-index: 5;
      width: min(280px, 86vw);
      transform: translateX(-102%);
      transition: transform 180ms ease;
      box-shadow: 18px 0 50px rgba(32, 51, 46, 0.18);
    }

    .lms-sidebar.open {
      transform: translateX(0);
    }

    .lms-card-grid,
    .lms-journey-track {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 640px) {
    .lms-topbar {
      padding: 0 1rem;
    }

    .lms-logout span {
      display: none;
    }

    .lms-card-grid,
    .lms-journey-track,
    .lms-empty-state {
      grid-template-columns: 1fr;
    }

    .lms-empty-state .lms-primary-action {
      width: 100%;
    }
  }
`;
